import React, { Component } from 'react';
import logo from '../assets/image/logo.png';
import '../css/PageNotFound.css';

const $ = window.$;

class PageNotFound extends Component {

    componentDidMount() {
        var content = $('.page-content')[0].clientHeight;
        $('.page-content').css('margin-top', (($(window).height() / 2) - ((content + 100) / 2)) + 'px')
    }

    render() {
        return(
            <div className="page-content">
                <img className="page-content-img" src={logo} />
                <div className="page-title-thai">ไม่พบหน้าที่คุณต้องการ</div>
                <div className="page-error-code">URL ผิดพลาด กรุณาลองใหม่อีกครั้ง หากไม่สามารถใช้งานได้กรุณาติดต่อสหกรณ์</div>
                <div className="page-error-contact">
                    <i className="fas fa-phone-volume" />
                    โทรศัพท์ : 043-873666 , 043-873667
                </div>
                <div className="page-error-contact">
                    <i className="fas fa-envelope" />
                    อีเมล์ : webmaster@klscoop.or.th
                </div>
                <div className="page-error-contact">
                    <i className="fab fa-line" />
                    Line : klscoop
                </div>
            </div>
        )
    }
}

export default PageNotFound;